interface CheckoutSheetParams {
  get: (key: string) => string | null
}

export const isCheckoutSheetOpen = (searchParams: CheckoutSheetParams, isWebView: boolean): boolean =>
  !isWebView && searchParams.get("signup") === "1" && !!searchParams.get("productId") && !!searchParams.get("variantId")

export const isSignupSheetOpen = (searchParams: CheckoutSheetParams, isWebView: boolean): boolean =>
  !isWebView && searchParams.get("signup") === "1" && !searchParams.get("productId") && !searchParams.get("variantId")

export type PageSearchParams = Record<string, string | string[] | undefined>

export const pageSearchParams = (searchParams: PageSearchParams): CheckoutSheetParams => ({
  get: (key) => {
    const value = searchParams[key]
    return (Array.isArray(value) ? value[0] : value) ?? null
  },
})
